import ExpandedOmniChannelSummaryComponent from './ExpandedOmniChannelSummary';

const ExpandedOmniChannelSummary = ExpandedOmniChannelSummaryComponent;

export default ExpandedOmniChannelSummary;
